import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router";
import { paths } from "./interface";
import Notification from "./miscellaneous/reatToastify/ToastNotification";
import RequestAuth from "./RequestAuth";
import Login from "./components/login/Login";

////////////////
// lazy mode


const Dashboard = lazy(
  () => import("./components/frontend/dashboard/Dashboard"),
);
const Settings = lazy(() => import("./components/frontend/settings/Settings"));

/************************
 * App
 * update react-router - https://reactrouter.com/upgrading/v6
 ***********************/
function App() {
  //  Disable right-click using useEffect hook
  useEffect(() => {
    const handleContextMenu = (e: any) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <>
      <Notification />

      <Suspense
        fallback={
          <div style={{ width: "100%", textAlign: "center", marginTop: "1em" }}>
            Loading.....
          </div>
        }
      >
        <Routes>
        
          <Route path={paths.login} element={<Login />} />
          <Route
            path={paths.dashboard}
            element={
              <RequestAuth>
                <Dashboard />
              </RequestAuth>
            }
          />
           <Route
            path={paths.settings}
            element={
              <RequestAuth>
                <Settings />
              </RequestAuth>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
